<div id="new-user-form" class="container">

  <div class="row">
    <h1 class="login-brand-name"></h1>
    <h2 class="login-product-name"></h2>

    <h3>Welcome to your client web app</h3>
    <h4>
      Hi {{salutationName}}, Please fill in the following details in order to activate your account
    </h4>

    <form [formGroup]="newUserPasswordForm" class="validated-form" #passwordForm="ngForm">

      <div formGroupName="Passwords" class="fieldset ui-grid ui-grid-responsive ui-fluid ui-g-6">

        <div class="ui-g form-group">
          <div class="ui-g-3">
            <label for="password">Password</label>
          </div>
          <div class="ui-g-9">
            <input class="form-control" formControlName="Password" placeholder="password" type="password" (blur)="passwordBlurred()" />
          </div>
        </div>

        <div class="ui-g form-group">
          <div class="ui-g-3">
            <label for="password2">Confirm Password</label>
          </div>
          <div class="ui-g-9">
            <input class="form-control" formControlName="ConfirmPassword" placeholder="re-enter password" type="password" />
            <div [hidden]="!passwordFieldBlurred || !newUserPasswordForm.controls['Passwords']?.errors?.passwordMatch" class="reset-password-validation-message"><i class="fa fa-times"></i> passwords do not match</div>
          </div>
        </div>
      </div>
      <div class="reset-password-validation-rules ui-g-6">
        <div class="reset-password-validation-heading"><span>Your password must contain the following:</span></div>
        <div class="reset-password-validation-rule"><span [hidden]="newUserPasswordForm.controls['Passwords']?.errors?.minlength || newUserPasswordForm.controls['Passwords']?.value?.length == 0"><i class="fa fa-check"></i></span><span [hidden]="!(newUserPasswordForm.controls['Passwords']?.errors?.minlength) && newUserPasswordForm.controls['Passwords']?.value?.length > 0 "><i class="fa fa-times"></i></span><span class="reset-password-validation-message"> at least 10 characters</span></div>
        <div class="reset-password-validation-rule"><span [hidden]="newUserPasswordForm.controls['Passwords']?.errors?.containsLowercase"><i class="fa fa-check"></i></span><span [hidden]="!(newUserPasswordForm.controls['Passwords']?.errors?.containsLowercase)"><i class="fa fa-times"></i></span><span class="reset-password-validation-message"> one lowercase</span></div>
        <div class="reset-password-validation-rule"><span [hidden]="newUserPasswordForm.controls['Passwords']?.errors?.containsUppercase"><i class="fa fa-check"></i></span><span [hidden]="!(newUserPasswordForm.controls['Passwords']?.errors?.containsUppercase)"><i class="fa fa-times"></i></span><span class="reset-password-validation-message"> one uppercase</span></div>
        <div class="reset-password-validation-rule"><span [hidden]="newUserPasswordForm.controls['Passwords']?.errors?.containsDigit"><i class="fa fa-check"></i></span><span [hidden]="!(newUserPasswordForm.controls['Passwords']?.errors?.containsDigit)"><i class="fa fa-times"></i></span><span class="reset-password-validation-message"> one digit</span></div>
        <div class="reset-password-validation-rule"><span [hidden]="newUserPasswordForm.controls['Passwords']?.errors?.containsSymbol"><i class="fa fa-check"></i></span><span [hidden]="!(newUserPasswordForm.controls['Passwords']?.errors?.containsSymbol)"><i class="fa fa-times"></i></span><span class="reset-password-validation-message"> one non letter or digit character</span></div>
      </div>
      <div class="button-bar ui-dialog-buttonpane ui-helper-clearfix text-center ui-g-12">
        <button id="continue-button" type="button" [disabled]="!newUserPasswordForm.valid" pButton (click)="save()" label="Continue"></button>
      </div>
    </form>
  </div>
</div>
